export default __webpack_public_path__ + "static/media/frame_corner_top_right_gray.5a73f0b1.png";